import Layout from "../components/Layout";
import axios from "axios";
import {BASE_URL} from "../utils/commonUrl";
import {useSelector} from "react-redux";
import React, {useEffect, useRef, useState} from "react";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {ProgressSpinner} from "primereact/progressspinner";
import {Toast} from "primereact/toast";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import QuarterNames from "../components/QuarterNames";


const EmployeeWillMatrix = () => {
    //const primeToast = useRef(null);
    const [isLoading, setIsLoading] = useState(false)
    const {user} = useSelector((state) => state["auth"]);
    const [employeeHighSkillHighWill, setEmployeeHighSkillHighWill] = useState([]);
    const [employeeHighSkillLowWill, setEmployeeHighSkillLowWill] = useState([]);
    const [employeeLowSkillHighWill, setEmployeeLowSkillHighWill] = useState([]);
    const [employeeLowSkillLowWill, setEmployeeLowSkillLowWill] = useState([]);
    const [selectedQuarterID, setSelectedQuarterID] = useState(0);

    const [globalFilterValueLSHW, setglobalFilterValueLSHW] = useState('');
    const [filtersLSHW, setFiltersLSHW] = useState(null);

    const [globalFilterValueHSHW, setglobalFilterValueHSHW] = useState('');
    const [filtersHSHW, setFiltersHSHW] = useState(null);

    const [globalFilterValueLSLW, setglobalFilterValueLSLW] = useState('');
    const [filtersLSLW, setFiltersLSLW] = useState(null);

    const [globalFilterValueHSLW, setglobalFilterValueHSLW] = useState('');
    const [filtersHSLW, setFiltersHSLW] = useState(null);

    const [monthNames,setMonthNames]=useState([]);

    useEffect(() => {
        initFiltersLSHW();
        initFiltersHSHW();
        initFiltersLSLW();
        initFiltersHSLW();
        getEmployeeWillMatrix(user.registerID,0, user.quarterID);
        GetAllMonthList();
    }, [])

    const GetAllMonthList = () => {
        axios.post(BASE_URL + `/api/utility/GetAllMonth`)
            .then((response) => {
                console.log(response);
                setMonthNames(
                    response.data.map((record) => {
                        return {
                            value: record.monthID,
                            label: record.monthName,
                        }
                    }),
                )
                //console.log(quarterNames);
            })
            .catch(function (error) {
                console.log(error);
            });
    };
    const getEmployeeWillMatrix = (id,joiningMonth,quarterID) => {
        const data = 
        {
            RegisterID:parseInt(id),
            JoiningMonthID:parseInt(joiningMonth),
            QuarterID: parseInt(quarterID)
        }

        console.log(data);

        axios.post(BASE_URL + "/api/EmployeeMatrix/SupervisorEmployeeWillMatrix", JSON.stringify(data))
            .then(response => {
                var data = response.data;
                setEmployeeHighSkillHighWill(data.filter( element => element.skillStatus ==="High Skill High Will"));
                setEmployeeHighSkillLowWill(data.filter( element => element.skillStatus ==="High Skill Low Will"));
                setEmployeeLowSkillHighWill(data.filter( element => element.skillStatus ==="Low Skill High Will"));
                setEmployeeLowSkillLowWill(data.filter( element => element.skillStatus ==="Low Skill Low Will"));                
            })
            .catch(e => {
                console.log(e)
            })
    }

    const childToParent = () => {
        var e = document.getElementById("ddlQuarter");
        var _selectedValue = e.value==="-1"?user.quarterID:e.value;

        var joiningMonth = document.getElementById("emp_Month");
        var _selectedJoiningMonth = joiningMonth.value==="-1"?0:joiningMonth.value;

        getEmployeeWillMatrix(user.registerID,_selectedJoiningMonth, _selectedValue);
      }

    const GetEmployeeReport=(id,quarterID)=>{
        window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/PerformanceEvaluationReport?SearchStr="+btoa("RegisterID=" + id+"&QuarterID=" + quarterID));
    }

    const employeebody = ({registerID,employeeName,quarterID}) => (
        <a href="#" style={{textDecoration:"none"}} onClick={() => GetEmployeeReport(registerID,quarterID)}> {employeeName}</a>
    )   

    const downloadMatrixFile = () => {
        var e = document.getElementById("ddlQuarter");
        var _selectedValue = e.value==="-1"?user.quarterID:e.value;
        getEmployeeWillMatrixList(user.registerID, _selectedValue);
    }

    const getEmployeeWillMatrixList=(id,quarterID)=>{
        window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/PMSSkillMatrixReport?SearchStr="+btoa("RegisterID=" + id+"&QuarterID=" + quarterID));
    }    
    
    const initFiltersLSHW = () => {
        setFiltersLSHW({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'employeeCode': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'employeeName': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'department': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'designation': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setglobalFilterValueLSHW('');
    }

    const clearFilterLSHW = () => {
        initFiltersLSHW();
    }

    const onGlobalFilterChangeLSHW = (e) => {
        const value = e.target.value;
        let _filters = {...filtersLSHW};
        _filters['global'].value = value;
        setFiltersLSHW(_filters);
        setglobalFilterValueLSHW(value);
    }

    const headerLSHW = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                            onClick={clearFilterLSHW}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValueLSHW} onChange={onGlobalFilterChangeLSHW}
                               placeholder="Keyword Search"/>
                </span>
                </div>
            </div>
        </div>
    );

    const initFiltersHSHW = () => {
        setFiltersHSHW({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'employeeCode': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'employeeName': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'department': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'designation': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setglobalFilterValueHSHW('');
    }

    const clearFilterHSHW = () => {
        initFiltersHSHW();
    }

    const onGlobalFilterChangeHSHW = (e) => {
        const value = e.target.value;
        let _filters = {...filtersHSHW};
        _filters['global'].value = value;
        setFiltersHSHW(_filters);
        setglobalFilterValueHSHW(value);
    }
	
	const headerHSHW = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                            onClick={clearFilterHSHW}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValueHSHW} onChange={onGlobalFilterChangeHSHW}
                               placeholder="Keyword Search"/>
                </span>
                </div>
            </div>
        </div>
    );
    
    const initFiltersLSLW = () => {
        setFiltersLSLW({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'employeeCode': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'employeeName': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'department': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'designation': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setglobalFilterValueLSLW('');
    }

    const clearFilterLSLW = () => {
        initFiltersLSLW();
    }

    const onGlobalFilterChangeLSLW = (e) => {
        const value = e.target.value;
        let _filters = {...filtersLSLW};
        _filters['global'].value = value;
        setFiltersLSLW(_filters);
        setglobalFilterValueLSLW(value);
    }
	
	const headerLSLW = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                            onClick={clearFilterLSLW}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValueLSLW} onChange={onGlobalFilterChangeLSLW}
                               placeholder="Keyword Search"/>
                </span>
                </div>
            </div>
        </div>
    );
    
    const initFiltersHSLW = () => {
        setFiltersHSLW({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'employeeCode': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'employeeName': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'department': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'designation': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setglobalFilterValueHSLW('');
    }

    const clearFilterHSLW = () => {
        initFiltersHSLW();
    }

    const onGlobalFilterChangeHSLW = (e) => {
        const value = e.target.value;
        let _filters = {...filtersHSLW};
        _filters['global'].value = value;
        setFiltersHSLW(_filters);
        setglobalFilterValueHSLW(value);
    }
	
	const headerHSLW = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                            onClick={clearFilterHSLW}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValueHSLW} onChange={onGlobalFilterChangeHSLW}
                               placeholder="Keyword Search"/>
                </span>
                </div>
            </div>
        </div>
    );

    // const headerHSLW = (
    //     <div className="table-header">
    //         <div className='d-flex justify-content-between'>
    //             <div>
    //                 <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
    //                         onClick={clearFilterHSLW}/>
    //                 <span className="p-input-icon-left"> <i className="pi pi-search"/>
    //                 <InputText value={globalFilterValueHSLW} onChange={onGlobalFilterChangeHSLW}
    //                            placeholder="Keyword Search"/>
    //             </span>
    //             </div>
    //         </div>
    //     </div>
    // );

    return (
        <Layout>
            <div className="card  text-dark bg-light mb-3">
            <div class="card-header">
                <div className="row">
                    <div className="col-3">
                        <h6><i class="bi bi-table"></i> Skill Will Matrix</h6>
                    </div>
                    <div className="col-md-3">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example"
                            id="emp_Month">
                            <option value="-1">--Select Join Month--</option>
                            {monthNames.map((value, index) => {
                                return <option key={index} value={value.value}>{value.label}</option>
                            })}

                        </select>
                    </div>
                    <div className="col-4">
                        <QuarterNames childToParent={childToParent}/>
                    </div>
                    <div className="col-2">
                        <button className="btn btn-primary btn-sm float-end" onClick={downloadMatrixFile}><i class="bi bi-chevron-double-down"></i> Download</button>
                    </div>
                </div>
            </div>
                        <div class="card-body">                 
            <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-6">
                    <div class="card text-white bg-primary mb-3">
                        <div class="card-header">
                            Low Skill High Will (Guide)
                        </div>
                        <div class="card-body" style={{overflow:'scroll'}}>
                 {isLoading ? <ProgressSpinner style={{width: '50px', height: '50px'}}/> : 
                        <DataTable value={employeeLowSkillHighWill} header={headerLSHW} 
                        globalFilterFields={['factoryName','employeeCode', 'employeeName', 'department', 'designation']}
                        filters={filtersLSHW}
                                resizableColumns
                                showGridlines                                
                                dataKey="userRoleID"  filterDisplay="menu"
                                // paginator rows={5} first={1}
                                scrollHeight="300px"
                                scrollDirection="both"
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
                            <Column field="registerID" header="registerID" hidden={true}/>
                            <Column field="quarterID" header="quarterID" hidden={true}/>
                            <Column field='factoryName' sortable header="Factory" />
                            <Column field='employeeCode' sortable header="Code" />
                            <Column field='employeeName' sortable header="Name" body={employeebody} />
                            <Column field='department' sortable header="Department" />
                            <Column field='designation' sortable header="Designation" />
                        </DataTable>
                        
                    //     <ul>
                    //     {employeeLowSkillHighWill.map((value, index) => (<div key={index}>
                    //         <li style={{listStyle: 'none', fontSize:'1rem'}}>
                    //             <b><a href="#" style={{color:"white", textDecoration:"none"}} onClick={() => GetEmployeeReport(value.registerID)}> {value.employeeName}.</a> </b> 
                    //         </li>
                    //     </div>))}
                    // </ul>
                    }
                        </div>
                    </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <div class="card text-white bg-rebeccapurple mb-3">
                        <div class="card-header">
                            High Skill High Will (Delegate)
                        </div>
                        <div class="card-body" style={{overflow:'scroll'}}> 
                        {isLoading ? <ProgressSpinner style={{width: '50px', height: '50px'}}/> : 
                        <DataTable value={employeeHighSkillHighWill} 
                        header={headerHSHW} 
                        globalFilterFields={['factoryName','employeeCode', 'employeeName', 'department', 'designation']}
                        filters={filtersHSHW}
                        scrollHeight="300px"
                        scrollDirection="both"
                        resizableColumns
                        showGridlines
                        dataKey="userRoleID"  filterDisplay="menu"
                        // paginator rows={5} first={1}
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
                    <Column field="registerID" header="registerID" hidden={true}/>
                    <Column field="quarterID" header="quarterID" hidden={true}/>
                    <Column field='factoryName' sortable header="Factory" />
                    <Column field='employeeCode' sortable header="Code" />
                    <Column field='employeeName' sortable header="Name" body={employeebody} />
                    <Column field='department' sortable header="Department" />
                    <Column field='designation' sortable header="Designation" />
                   
                </DataTable>
                        // <ul>
                        // {employeeHighSkillHighWill.map((value, index) => (<div key={index}>
                        //     <li style={{listStyle: 'none', fontSize:'1rem'}}>
                        //         <b><a href="#" style={{color:"white", textDecoration:"none"}} onClick={() => GetEmployeeReport(value.registerID)}> {value.employeeName}.</a> </b> 
                        //     </li>
                        // </div>))}
                        // </ul>
                    }
                        </div>
                    </div>
                </div>
                
            </div>
            <div className="row">
                
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <div class="card text-white bg-warning mb-3">
                        <div class="card-header">
                            Low Skill Low Will (Direct)
                        </div>
                        <div class="card-body" style={{overflow:'scroll'}}>
                        {isLoading ? <ProgressSpinner style={{width: '50px', height: '50px'}}/> : 
                        <DataTable value={employeeLowSkillLowWill} 
                        header={headerLSLW} 
                        globalFilterFields={['factoryName','employeeCode', 'employeeName', 'department', 'designation']}
                        filters={filtersLSLW}
                                resizableColumns
                                showGridlines
                                dataKey="userRoleID"  filterDisplay="menu"
                                // paginator rows={5} first={1}
                                scrollHeight="300px"
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
                            <Column field="registerID" header="registerID" hidden={true}/>
                            <Column field="quarterID" header="quarterID" hidden={true}/>
                            <Column field='factoryName' sortable header="Factory" />
                            <Column field='employeeCode' sortable header="Code" />
                            <Column field='employeeName' sortable header="Name" body={employeebody} />
                            <Column field='department' sortable header="Department" />
                            <Column field='designation' sortable header="Designation" />                           
                        </DataTable>
                        // <ul>
                        // {employeeLowSkillLowWill.map((value, index) => (<div key={index}>
                        //     <li style={{listStyle: 'none', fontSize:'1rem'}}>
                        //         <b><a href="#" style={{color:"white", textDecoration:"none"}} onClick={() => GetEmployeeReport(value.registerID)}> {value.employeeName}.</a> </b> 
                        //     </li>
                        // </div>))}
                        // </ul>
                        }
                        </div>
                    </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <div class="card text-white bg-primary mb-3">
                        <div class="card-header">
                            High Skill Low Will (Excite)
                        </div>
                        <div class="card-body" style={{overflow:'scroll'}}>
                        {isLoading ? <ProgressSpinner style={{width: '50px', height: '50px'}}/> : 
                            <DataTable value={employeeHighSkillLowWill} 
                            header={headerHSLW} 
                            globalFilterFields={['factoryName','employeeCode', 'employeeName', 'department', 'designation']}
                            filters={filtersHSLW}
                            resizableColumns
                            showGridlines
                            dataKey="userRoleID"  filterDisplay="menu"
                            // paginator rows={5} first={1}
                            scrollHeight="300px"
                                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
                                <Column field="registerID" header="registerID" hidden={true}/>
                                <Column field="quarterID" header="quarterID" hidden={true}/>
                                <Column field='factoryName' sortable header="Factory" />
                                <Column field='employeeCode' sortable header="Code" />
                                <Column field='employeeName' sortable header="Name" body={employeebody} />
                                <Column field='department' sortable header="Department" />
                                <Column field='designation' sortable header="Designation" />                           
                            </DataTable>
                        // <ul>
                        // {employeeHighSkillLowWill.map((value, index) => (<div key={index}>
                        //     <li style={{listStyle: 'none', fontSize:'1rem'}}>
                        //     <b><a href="#" style={{color:"white", textDecoration:"none"}} onClick={() => GetEmployeeReport(value.registerID)}> {value.employeeName}.</a> </b> 
                        //     </li>
                        // </div>))}
                        // </ul>
                    }
                        </div>
                    </div>
                </div>
            </div>
            </div>
            </div> 
        </Layout>
    )
}

export default EmployeeWillMatrix